/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfficeNameDto } from '../../models/office-name-dto';

export interface OfficeControllerFindAllDropdown$Params {
  initial: boolean;
  sIds?: Array<number>;
}

export function officeControllerFindAllDropdown(http: HttpClient, rootUrl: string, params: OfficeControllerFindAllDropdown$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfficeNameDto>>> {
  const rb = new RequestBuilder(rootUrl, officeControllerFindAllDropdown.PATH, 'get');
  if (params) {
    rb.query('initial', params.initial, {});
    rb.query('sIds', params.sIds, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OfficeNameDto>>;
    })
  );
}

officeControllerFindAllDropdown.PATH = '/api/office/dropdown';
